import { useProductPageStore } from '../../contexts/ProductPageStore'
import styles from './fitmentAccordion.module.scss'

import React, { useState } from 'react'
import { useInView } from 'react-intersection-observer'

import { useIntersectionObserver } from '@speedwaymotors/clutch/Hooks/useIntersectionObserver'

import Accordion from 'Clutch/Molecules/Accordion'

import Card from 'Clutch/Atoms/Card'
import Svg from 'Clutch/Atoms/Svg'
import Typography from 'Clutch/Atoms/Typography'

const FitmentAccordion = ({}) => {
  const isFitmentAccordionOpen = useProductPageStore((x) => x.isFitmentAccordionOpen)
  const fitment = useProductPageStore((x) => x.fitmentDM)
  const toggleAccordion = useProductPageStore((x) => x.toggleAccordion)
  const fitmentClosedRef = useIntersectionObserver('fitmentClosedInView')

  const [dummyRef, _] = useInView()

  if (!fitment || fitment.length === 0) {
    return false
  }

  const fitmentAccordionSummary = (
    <Typography as={'h2'} size={1.25} font={'heading'}>
      Fitment
    </Typography>
  )

  return (
    <Card fill dataTestId={'pdp_fitment'} ref={isFitmentAccordionOpen ? dummyRef : fitmentClosedRef}>
      <Accordion
        intent={'action'}
        iconClosed={'plus'}
        iconOpened={'minus'}
        size={0.875}
        summary={fitmentAccordionSummary}
        fill
        segmentAccordionName={'pdp fitment'}
        defaultOpen={isFitmentAccordionOpen}
        onChange={(isOpen) => toggleAccordion('Fitment', isOpen)}
      >
        <div className={styles.ymmContainer}>
          {(fitment || []).map((entry, index) => (
            <YmmEntry key={index} entry={entry} />
          ))}
        </div>
      </Accordion>
    </Card>
  )
}

const YmmEntry = ({ entry }) => {
  const [collapsed, setCollapsed] = useState(true)

  if (!entry || !entry.make || !entry.model || !entry.yearFrom || !entry.yearTo) {
    return false
  }

  const yearDisplay = entry.yearFrom === entry.yearTo ? entry.yearFrom : `${entry.yearFrom}-${entry.yearTo}`
  return (
    <div className={styles.ymmEntry}>
      <div
        className={styles.ymmSummary}
        onClick={() => setCollapsed((prev) => !prev)}
        style={{ cursor: 'pointer', userSelect: 'none' }}
        aria-expanded={!collapsed}
        tabIndex={0}
        id={`ymm-summary-${entry.make}-${entry.model}-${yearDisplay}`}
      >
        {entry.engines?.length && (
          <Svg icon={collapsed ? 'chevron-down' : 'chevron-up'} size={0.75} className={styles.chevron} />
        )}
        <Typography size={1} font={'bold'}>
          {yearDisplay} {entry.make} {entry.model}
        </Typography>
      </div>
      <ul className={collapsed ? styles.collapsed : styles.engineList}>
        {(entry.engines || []).map((engine, index) => (
          <EngineEntry key={index} entry={engine} index={index} />
        ))}
      </ul>
    </div>
  )
}

const EngineEntry = ({ entry, index }) => {
  if (!entry || !entry.engineDisplayName) {
    return false
  }

  return (
    entry.engineDisplayName && (
      <li className={styles.engineEntry} id={`engine-${entry.engineDisplayName}-${index}`}>
        <Typography size={1} font={'body'}>
          {entry.engineDisplayName}
        </Typography>
      </li>
    )
  )
}

export default FitmentAccordion
